import styled, { css } from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  background: var(--fd-colors-background-surface);
  border-radius: var(--fd-radii-border-radius-020);
  overflow: hidden;
`;

export const Title = styled.div<{ divider: boolean }>`
  width: 100%;
  padding: var(--fd-space-space-6) var(--fd-space-space-4);
  ${({ divider }) =>
    divider &&
    css`
      border-bottom: 1px solid var(--fd-colors-border-subtle);
    `};
`;

// TODO: on mobile this component will be sticky to the bottom
export const Footer = styled.footer`
  width: 100%;
  padding: var(--fd-space-space-4);
  border-top: 1px solid var(--fd-colors-border-subtle);
`;
